import React from 'react';
import { Box, Typography } from '@mui/material';
import ListAltIcon from '@mui/icons-material/ListAlt';
import {
  emptyStateBoxSx,
  emptyStateHintSx,
  emptyStateIconSx,
  emptyStateTitleSx,
} from '../../Map/components/UserLotListsPanel/UserLotListsPanel.styles';

/**
 * Empty state del listado de parcelas CAD. Mismo chrome que el detalle de lista.
 * @param {{ hasActiveFilter?: boolean }} props
 */
export default function ShowroomParcelListEmpty({ hasActiveFilter = false }) {
  return (
    <Box sx={emptyStateBoxSx}>
      <ListAltIcon sx={emptyStateIconSx} />
      <Typography sx={emptyStateTitleSx}>
        {hasActiveFilter ? 'No hay resultados que coincidan' : 'No hay lotes para mostrar'}
      </Typography>
      {hasActiveFilter ? (
        <Typography sx={emptyStateHintSx}>
          Probá otra búsqueda o limpiá el filtro.
        </Typography>
      ) : null}
    </Box>
  );
}
